import { render } from "./House.vue?vue&type=template&id=5e4fef0c&scoped=true"
import script from "./House.vue?vue&type=script&lang=js"
export * from "./House.vue?vue&type=script&lang=js"

import "./House.vue?vue&type=style&index=0&id=5e4fef0c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Pacto_console/Pacto_console/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e4fef0c"]])

export default __exports__